module.exports = __webpack_public_path__ + "img/configuration.1c51f38.svg";